module.exports = __webpack_public_path__ + "img/ods.02dadc9e.png";